import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

const createAbility = { action: 'create', subject: 'attendance scenario' };
const createDenialMessage = "You don't have permission to create attendance scenarios.";
const viewDenialMessage = "You don't have permission to view attendance scenarios.";

function canViewScenarios({ gate }) {
    return gate.allows('viewAny', 'AttendanceScenario') || gate.allows('configure', 'AttendanceScenario');
}

export default [
    {
        path: '/admin/attendance/scenarios',
        name: 'attendance-scenario-index',
        beforeEnter: FeatureMiddleware('ATTEND'),
        component: () => import('@/pages/attendance-scenarios/AttendanceScenarioIndex.vue'),
        meta: {
            title: 'Attendance',
            middleware: [GateKeeperMiddleware],
            ability: canViewScenarios,
            denialMessage: viewDenialMessage,
            dataTablePage: true,
        },
    },
    {
        path: '/admin/attendance/scenarios/new',
        name: 'attendance-scenario-create',
        beforeEnter: FeatureMiddleware('ATTEND'),
        component: () => import('@/pages/attendance-scenarios/AttendanceScenarioCreate.vue'),
        meta: {
            title: 'Create Attendance Scenario',
            middleware: [GateKeeperMiddleware],
            ability: createAbility,
            denialMessage: createDenialMessage,
        },
    },
    {
        path: '/admin/attendance/scenarios/:id(\\d+)',
        name: 'attendance-scenario-show',
        beforeEnter: FeatureMiddleware('ATTEND'),
        component: () => import('@/pages/attendance-scenarios/AttendanceScenarioShow.vue'),
        meta: {
            title: 'Attendance Scenario',
            middleware: [GateKeeperMiddleware],
            ability: canViewScenarios,
            denialMessage: viewDenialMessage,
        },
    },
    {
        path: '/admin/attendance/scenarios/:id(\\d+)/edit',
        name: 'attendance-scenario-edit',
        beforeEnter: FeatureMiddleware('ATTEND'),
        component: () => import('@/pages/attendance-scenarios/AttendanceScenarioEdit.vue'),
        meta: {
            title: 'Edit Attendance Scenario',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'edit', subject: 'attendance scenario' },
            denialMessage: "You don't have permission to edit attendance scenarios.",
        },
    },
];
